<template>
  <v-footer height="40" app>
    <div class="text-caption text-disabled">Scriptworx v0.3-alpha</div>

    <div class="text-caption text-disabled" style="position: absolute; right: 16px">
      &copy; 2024-{{ new Date().getFullYear() }}
      <span class="d-none d-sm-inline-block">Adhereon Pty Ltd</span>
      —
      <a
        class="text-decoration-none on-surface"
        href="https://www.adhereon.com.au"
        rel="noopener noreferrer"
        target="_blank"
      >
        All Rights Reserved
      </a>
    </div>
  </v-footer>
</template>

<script setup></script>
